import { render } from "./treemenu.vue?vue&type=template&id=46cfb140"
import script from "./treemenu.vue?vue&type=script&lang=js"
export * from "./treemenu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/oralhealthmap.uz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__